module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-intern-72e44a61346f449bfdf916ca77619cdb.jpg";